import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";

import Button from "@mui/material/Button";
import { FormikProps } from "formik";
import { RequestReason } from "../sharedTypes";
import { CustomerBusinessUnitData as Type } from "../customer-model";
import businessUnitJSON from "../../../lib/language/businessUnit.json";
import { useTranslation } from "next-i18next";

interface Props {
  reasonForRequestData: RequestReason[];
  requestedReasons: string[];
  formik: FormikProps<Type>;
}

interface BusinessUnit {
  text: string;
  value: string;
  langKey: string;
  region: string;
  checked: boolean;
}

const _businessUnits = businessUnitJSON as BusinessUnit[];
const checkedBusinessUnit: string[] = [];

/**
 * Customer Access Business Unit step / screen.
 */
export function CustomerBusinessUnitStep({
  formik,
}: Props) {
  const { t } = useTranslation();
  const [businessUnits, setBusinessUnits] =
    useState<BusinessUnit[]>(_businessUnits);
  
  const createListBusinessUnit = () => {
    if (checkedBusinessUnit.length > 1) {
      businessUnits.forEach((item) => {
        item.text = getTranslatedBusinessUnit(item);
        if (checkedBusinessUnit.some((x) => x === item.text)) {
          item.checked = true;
        }
      });
      setBusinessUnits(businessUnits);
    }
    setBusinessUnits(businessUnits);
  };

  const getTranslatedBusinessUnit = (businessUnit: BusinessUnit) => {
    const translationKey = `request_access:customer_access.${businessUnit.langKey}`;
    return (
      t(translationKey)
    );
  };

  const handleCheck = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const checked = event.target.checked;
    businessUnits.forEach((businessUnit) => {
      if (businessUnit.value === name) {
        businessUnit.checked = checked;
        addRemovetoList(name, checked);
        updateFormik();
      }
    });
    setBusinessUnits(businessUnits);
  };

  const addRemovetoList = (name: string, checked: boolean) => {
    if (checked) {
      checkedBusinessUnit.push(name);
    } else {
      const index = checkedBusinessUnit.indexOf(name);
      checkedBusinessUnit.splice(index, 1);
    }
  };

  const updateFormik = () => {
    formik.values.businessUnits = checkedBusinessUnit;
  };

  useEffect(() => {
    createListBusinessUnit();
    // TODO: fix this hook dependency inconsistency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  return (
    <Box>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "1.75em",
            fontWeight: "bold",
          }}
        >
          {t("request_access:customer_access.business_unit")}
        </Typography>
      </Box>
      <Box sx={{ fontSize: "14px", mb: "12px", textAlign: "left" }}>
        {t("request_access:customer_access.business_information_summary")}
      </Box>

      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            display: "grid",
          }}
        >
          <Grid container direction={"column"}>
            {businessUnits.map((item, index: number) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        handleCheck(e);
                        formik.handleChange(e);
                      }}
                      name={item.value}
                      key={item.value}
                      checked={item.checked}
                    />
                  }
                  // label={item.text}
                  label={getTranslatedBusinessUnit(item)}
                  sx={{ textAlign: "left" }}
                  key={item.value}
                />
            ))}
          </Grid>
        </Box>

        <Box mt={12}>
          <Button
            sx={{ width: "100%", mb: 4 }}
            type="submit"
            disabled={!(formik.dirty && formik.isValid)}
          >
            {t("common:common.continue")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
